/**
 * React Query persistence was introduced as a warm-cache optimisation, but
 * the application cannot safely bind its IndexedDB snapshot to an account at
 * bootstrap: authStore intentionally persists neither the user nor tokens.
 *
 * Persisting the broad query cache also stored private message pages, paused
 * mutation variables and short-lived signed media URLs. A legacy message
 * entry with the old non-infinite shape caused TanStack to synchronously read
 * `data.pages.length` and unmount the whole React tree.
 *
 * The reliable P0 policy is therefore fail-closed: do not hydrate or attach a
 * React Query persister. chatStore/outbox retain their purpose-built offline
 * state; server-backed queries are fetched fresh. Remove old snapshots on a
 * best-effort basis without blocking first paint. A future encrypted,
 * account-bound allowlist can replace this purge explicitly.
 */

import { idbStorage } from './idbStorage';

const UNSAFE_QUERY_SNAPSHOT_KEYS = [
  'rq-snapshot',
  'rq-snapshot-v2',
];

export async function purgePersistedQueryCache(): Promise<void> {
  await Promise.all(
    UNSAFE_QUERY_SNAPSHOT_KEYS.map((key) => idbStorage.removeItem?.(key)),
  );
}
